import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Search, X } from "lucide-react";

export default function PatientsPage() {
  const [list, setList] = useState([]);
  const [search, setSearch] = useState("");
  const [open, setOpen] = useState(null);
  useEffect(() => {
    api.get("/patients", { params: { search: search || undefined } }).then((r) => setList(r.data));
  }, [search]);
  return (
    <div className="space-y-4" data-testid="patients-page">
      <div className="flex items-center justify-between flex-wrap gap-2">
        <div>
          <h1 className="text-2xl font-display font-bold text-slate-900">Patients</h1>
          <p className="text-slate-500 text-sm">Directory from your appointments</p>
        </div>
        <div className="relative">
          <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
          <input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search" className="pl-8 pr-3 py-2 border border-slate-300 rounded-lg text-sm bg-white w-64" data-testid="patients-search-input" />
        </div>
      </div>
      <div className="bg-white rounded-2xl border border-slate-200 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-slate-500 text-xs uppercase tracking-wider">
            <tr><th className="text-left px-5 py-3">Patient</th><th className="text-left px-5 py-3">Phone</th><th className="text-left px-5 py-3">Email</th><th className="text-left px-5 py-3">Appointments</th><th className="text-left px-5 py-3">Last visit</th></tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {list.map((p) => (
              <tr key={p.id} data-testid={`patient-row-${p.phone}`} className="hover:bg-slate-50/60 cursor-pointer" onClick={() => setOpen(p.id)}>
                <td className="px-5 py-3 font-medium text-slate-900">{p.name}</td>
                <td className="px-5 py-3 text-slate-700">{p.phone}</td>
                <td className="px-5 py-3 text-slate-700">{p.email || "—"}</td>
                <td className="px-5 py-3">{p.appointment_count}</td>
                <td className="px-5 py-3 text-slate-500">{p.last_seen_at ? new Date(p.last_seen_at).toLocaleDateString() : "—"}</td>
              </tr>
            ))}
            {list.length === 0 && <tr><td colSpan={5} className="px-5 py-6 text-slate-500">No patients yet.</td></tr>}
          </tbody>
        </table>
      </div>
      {open && <PatientDrawer id={open} onClose={() => setOpen(null)} />}
    </div>
  );
}

function PatientDrawer({ id, onClose }) {
  const [data, setData] = useState(null);
  useEffect(() => { api.get(`/patients/${id}`).then((r) => setData(r.data)); }, [id]);
  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex justify-end" onClick={onClose} data-testid="patient-drawer">
      <div className="w-full max-w-lg bg-white h-full overflow-y-auto p-6" onClick={(e) => e.stopPropagation()}>
        {!data ? <div className="text-slate-500">Loading...</div> : (
          <>
            <div className="flex items-start justify-between">
              <div>
                <h3 className="text-xl font-display font-bold text-slate-900">{data.patient.name}</h3>
                <div className="text-sm text-slate-500">{data.patient.phone}{data.patient.email ? ` · ${data.patient.email}` : ""}</div>
              </div>
              <button onClick={onClose} className="p-2 hover:bg-slate-100 rounded-lg"><X size={18} /></button>
            </div>
            <div className="mt-5 font-semibold text-slate-800 text-sm">Appointment history</div>
            <div className="mt-2 space-y-2">
              {data.appointments.map((a) => (
                <div key={a.id} className="border border-slate-200 rounded-lg p-3">
                  <div className="flex items-center justify-between">
                    <div className="font-mono text-xs text-slate-500">{a.reference}</div>
                    <span className="px-2 py-0.5 rounded-full text-[11px] font-semibold capitalize bg-slate-100 text-slate-700">{a.status.replace("_", " ")}</span>
                  </div>
                  <div className="text-sm font-medium text-slate-900 mt-1">{a.date} · {a.start_time}</div>
                  <div className="text-xs text-slate-500">{a.consultation_type}</div>
                </div>
              ))}
              {data.appointments.length === 0 && <div className="text-sm text-slate-500">No history.</div>}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
